import { ThemeFont } from './types';

export const DEFAULT_STYLES = {
  h1: { size: 36, leading: 1.3, marginBottom: 16 },
  h2: { size: 30, leading: 1.3, marginBottom: 12 },
  h3: { size: 24, leading: 1.3, marginBottom: 8 },
  content: { size: 16, leading: 1.5, marginBottom: 8 },
} as const;

// UI Constants
export const ANIMATION_DURATION_MS = 150;
export const FONT_SIZE_MIN = 8;
export const FONT_SIZE_MAX = 120;
export const LINE_HEIGHT_MIN = 0.8;
export const LINE_HEIGHT_MAX = 3.0;
export const LINE_HEIGHT_STEP = 0.1;
export const MARGIN_BOTTOM_MIN = 0;
export const MARGIN_BOTTOM_MAX = 80;
export const MARGIN_BOTTOM_STEP = 1;

export const BUILT_IN_FONTS: ThemeFont[] = [
  {
    id: 'system',
    url: '',
    name: 'System',
  },
  {
    id: 'inter',
    url: '',
    name: 'Inter',
  },
  {
    id: 'lexend',
    url: '/fonts/lexend.css',
    name: 'Lexend',
  },
  {
    id: 'yeseva',
    url: 'https://fonts.bunny.net/css?family=yeseva-one:400',
    name: 'Yeseva One',
  },
  {
    id: 'libre-baskerville',
    url: 'https://fonts.bunny.net/css?family=libre-baskerville:400,400i,700,700i',
    name: 'Libre Baskerville',
  },
  {
    id: 'vollkorn',
    url: 'https://fonts.bunny.net/css?family=vollkorn:400,400i,700',
    name: 'Vollkorn',
  },
  {
    id: 'petit-formal-script',
    url: 'https://fonts.bunny.net/css?family=petit-formal-script:400',
    name: 'Petit Formal Script',
  },
  {
    id: 'montserrat',
    url: 'https://fonts.bunny.net/css?family=montserrat:400,700',
    name: 'Montserrat',
  },
  {
    id: 'reenie-beanie',
    url: 'https://fonts.bunny.net/css?family=reenie-beanie:400',
    name: 'Reenie Beanie',
  },
  {
    id: 'cantarell',
    url: 'https://fonts.bunny.net/css?family=cantarell:400,400i,700,700i',
    name: 'Cantarell',
  },
];

// Font name to CSS font-family mapping
export const FONT_FAMILY_MAP: Record<string, string> = {
  System: 'ui-sans-serif, system-ui, sans-serif',
  Inter: 'Inter, ui-sans-serif, system-ui, sans-serif',
  Lexend: 'Lexend, ui-sans-serif, system-ui, sans-serif',
  'Yeseva One': "'Yeseva One', cursive",
  'Libre Baskerville': "'Libre Baskerville', serif",
  Vollkorn: 'Vollkorn, serif',
  'Petit Formal Script': "'Petit Formal Script', cursive",
  Montserrat: "'Montserrat', system-ui, sans-serif",
  'Reenie Beanie': "'Reenie Beanie', cursive",
  Cantarell: 'Cantarell, serif',
};
